import "symbol-observable";
import React, { Suspense } from "react";
import "./index.css";
import { createRoot } from "react-dom/client";
import LogoSvg from "./assets/LogoSpinner.svg?react";

const Root = React.lazy(() => import("./Root"));

const container = document.getElementById("app");
if (!container) {
  throw new Error("Failed to find the root element");
}

const root = createRoot(container);
root.render(
  <Suspense
    fallback={
      <div style={{ display: "flex", justifyContent: "center", margin: "100px 0" }}>
        <LogoSvg />
      </div>
    }
  >
    <Root />
  </Suspense>,
);
